import { render } from "./ExamTableList.vue?vue&type=template&id=0a765dca&scoped=true"
import script from "./ExamTableList.vue?vue&type=script&lang=js"
export * from "./ExamTableList.vue?vue&type=script&lang=js"

import "./ExamTableList.vue?vue&type=style&index=0&id=0a765dca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a765dca"]])

export default __exports__